import { CHART_BAR_LAYOUT } from './ChartBar.constants'

export function checkIsChartBarColumns(layout) {
  return layout === CHART_BAR_LAYOUT.columns
}
